export const assistantsDay = async (err) => {
  if (err) {
    console.error(err);
  }

  /*
   * Filter assistants day hotels by category
   */
  const assistantsDayFilter = document.querySelectorAll(
    '.assistants-day-cat-filters .cat-item',
  );
  if (assistantsDayFilter) {
    const showAllHotelsListElement = document.createElement('li');
    const showAllHotelsLink = document.createElement('a');
    showAllHotelsListElement.classList.add(
      'cat-item',
      'show-all-hotels',
      'active',
    );

    showAllHotelsLink.setAttribute('href', '#');
    showAllHotelsLink.innerText = 'Alle anzeigen';

    showAllHotelsListElement.appendChild(showAllHotelsLink);

    document
      .querySelector('.assistants-day-cat-filters')
      .prepend(showAllHotelsListElement);

    document.addEventListener('click', function (e) {
      if (e.target.closest('.assistants-day-cat-filters .cat-item')) {
        e.preventDefault();
        var filter = e.target.closest('.assistants-day-cat-filters .cat-item');

        assistantsDayFilter.forEach((f) => {
          f.classList.remove('active');
        });

        showAllHotelsListElement.classList.remove('active');

        filter.classList.add('active');

        var allHotels = '';
        // set active class on filter
        allHotels = document.querySelectorAll('.assistantsday-hotel');
        // alle-anzeigen
        if (filter.classList.contains('show-all-hotels')) {
          allHotels.forEach((hotel) => {
            hotel.style.display = 'grid';
          });
          showAllHotelsListElement.classList.add('active');
        } else {
          allHotels.forEach((hotel) => {
            hotel.style.display = 'none';
          });

          var filterValueClass =
            'assistance-kategorie-' + filter.textContent.toLowerCase();
          var filteredAssistantsDayHotels = document.querySelectorAll(
            '.' + filterValueClass,
          );
          filteredAssistantsDayHotels.forEach((filteredAssistantsDayHotel) => {
            filteredAssistantsDayHotel.style.display = 'grid';
          });
        }
      }

      if (e.target.closest('.taxonomy-assistance-kategorie a')) {
        e.preventDefault();
      }
    });
  }
};

import.meta.webpackHot?.accept(assistantsDay);
